// @ts-expect-error Untyped module
import FireAlarmApp from 'FireAlarmUi/js/FireAlarmApp';
import { SignupEmbedderOptions } from 'signup-embedder';
export const setupFirealarm = () => {
  const shouldShowFireAlarm = SignupEmbedderOptions.getOptionValue(SignupEmbedderOptions.SIGNUP_SHOULD_SHOW_FIREALARM);

  if (shouldShowFireAlarm) {
    const fireAlarm = new FireAlarmApp(window.hubspot, {
      appName: 'signup-ui-lego',
      containers: {
        default: {
          before: document.querySelector('.page')
        }
      }
    });
    window.hubspot[FireAlarmApp.HUBSPOT_FIREALARM_KEY] = fireAlarm;
    fireAlarm.start();
  }
};